exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".card.timer-card {\n  width: 100%;\n  margin: 0;\n  border-top: 1px solid #eee; }\n  @media (min-width: 600px) {\n    .card.timer-card {\n      width: calc(100% - 55px);\n      border-top: none;\n      border-left: 1px solid #eee; } }\n\nsection.timer-card-wrapper {\n  margin: 0 0.75rem;\n  background: white; }\n\n.side-button-wrapper {\n  width: 100%;\n  text-align: center; }\n  @media (min-width: 600px) {\n    .side-button-wrapper {\n      width: 55px;\n      float: left !important; } }\n\n@media (min-width: 600px) {\n  .side-button {\n    width: 55px; } }\n\n.side-button.drag-handle {\n  display: none; }\n  @media (min-width: 992px) {\n    .side-button.drag-handle {\n      display: inline-block; } }\n\nblockquote.card-description {\n  border-color: #29b6f6; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/styles/TimeCard.scss
// module id = 86
// module chunks = 0